import { useEffect, useState } from "react";

// Detour Coffee Co. is open 7:30 AM – 10:00 PM every day (Arlington, VA · Eastern time).
const OPEN_MIN = 7 * 60 + 30; // 7:30 AM
const CLOSE_MIN = 22 * 60; // 10:00 PM
const TZ = "America/New_York";

const easternMinutes = () => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  }).formatToParts(new Date());
  const hour = Number(parts.find((p) => p.type === "hour").value) % 24;
  const minute = Number(parts.find((p) => p.type === "minute").value);
  return hour * 60 + minute;
};

const computeStatus = () => {
  const now = easternMinutes();
  const open = now >= OPEN_MIN && now < CLOSE_MIN;
  return {
    open,
    statusText: open ? "Open now" : "Closed",
    detail: open ? "until 10 PM" : "opens 7:30 AM",
  };
};

export const useOpenStatus = () => {
  const [status, setStatus] = useState(computeStatus);
  useEffect(() => {
    const id = setInterval(() => setStatus(computeStatus()), 30000);
    return () => clearInterval(id);
  }, []);
  return status;
};
